module.exports = __webpack_public_path__ + "img/arrow-select.dd360295.svg";